import { useMutation, useQuery } from "@apollo/client";
import { Empty, message, Skeleton } from "antd";
import {
  StaffApplicantProfileCitizenshipViewContainerApplicantUserDocument,
  StaffApplicantProfileCitizenshipEditContainerApplicantUserUpdateDocument,
} from "../../../../generated";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
import { lookupCountryQuery } from './staff-components-country-query'
import { useNavigate } from "react-router-dom";
import { ApplicantProfileCitizenshipEdit } from "./applicant-profile-citizenship-edit";

interface ApplicantProfileCitizenshipEditContainerProps {
  applicantId: string;
};

export const ApplicantProfileCitizenshipEditContainer: React.FC<ApplicantProfileCitizenshipEditContainerProps> = ({applicantId}) => {
 
  const navigate = useNavigate();
  
  const {
    data: countryCitizenshipData,
    loading: countryCitizenshipDataLoading,
    error: countryCitizenshipError,
  } = useQuery(StaffApplicantProfileCitizenshipViewContainerApplicantUserDocument, {
    variables: {
      applicantUserId: applicantId,
    },
  });

  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const [applicantUserUpdate] = useMutation(
    StaffApplicantProfileCitizenshipEditContainerApplicantUserUpdateDocument,
    {
      refetchQueries: [
        {
          query: StaffApplicantProfileCitizenshipViewContainerApplicantUserDocument,
          variables: {
            applicantUserId: applicantId,
          },
        },
      ],
      awaitRefetchQueries: true,
    }
  );

  const handleSave = async (data: any) => {
    console.log("data: ", data);
    try {
      await applicantUserUpdate({
        variables: {
          input: {
            id: applicantId,
            applicantUserDetails: {
              personalInformation: {
                citizenship: {
                  currentCitizenOf: data.currentCitizenOf,
                },
              },
            },
          },
        },
      });
      message.success("Citizenship details updated");
      handleEdit();
    } catch (error) {
      message.error(`Error Updating Citizenship: ${JSON.stringify(error)}`);
    }
  };

  const handleEdit = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, "/view");
    navigate(newPath);
  };

  if (countryLoading || countryCitizenshipDataLoading) {
    return <Skeleton active />;
  }

  if (
    countryCitizenshipError ||
    !countryCitizenshipData?.applicantUser?.personalInformation?.citizenship
  ) {
    console.log(
      "countryCitizenshipData",
      JSON.stringify(countryCitizenshipData, null, 2)
    );
    return (
      <Empty
        description={`There was an error loading the citizenship data. Please try again! ${countryCitizenshipError}`}
      />
    );
  }

  if (countryError || !countryData?.countries?.eventPayload?.countries) {
    console.log("countryData", JSON.stringify(countryData, null, 2));
    return (
      <Empty
        description={`There was an error loading the country data. Please try again! ${countryError}`}
      />
    );
  }

  return (
    <ComponentQueryLoader
      hasData={
        countryData?.countries &&
        countryCitizenshipData?.applicantUser?.personalInformation?.citizenship
      }
      loading={countryCitizenshipDataLoading || countryLoading}
      error={countryCitizenshipError || countryError}
      hasDataComponent={
        <ApplicantProfileCitizenshipEdit
          citizenship={
            countryCitizenshipData?.applicantUser?.personalInformation
              ?.citizenship
          }
          countries={countryData?.countries?.eventPayload?.countries}
          onCancel={handleEdit}
          onSave={handleSave}
        />
      }
    />
  );
};
